
// Fields

(function () {

	var field = {

		setMask: function () {

			if ( !window.IMask ) return console.error( 'Sorry, IMask plugin not found!' )

			for ( var i = 0, el; el = this.els[i]; i++ ) {
				IMask( el, {
					mask: el.getAttribute( 'data-mask' )
				});
			}

		},

		init: function () {

			this.els = document.querySelectorAll( '.field__el[data-mask]' );

			if ( !this.els ) return

			this.setMask();

			return this

		}

	}

	return field.init();

})();
